<template>
    <SelectAllNotice
        v-if="isNoticeShown"
        :selected="selected"
        :total-count="totalCount"
        @selectAll="onSelectAll"
        @dismiss="hideNotice"
    />
</template>

<script lang="ts">
import { defineComponent, type PropType } from "vue";

import { MultiviewEvent } from "@/enums/multiview";
import bus from "@/bus";
import SelectAllNotice from "@/components/Campaign/SelectAllNotice.vue";
import type { InstanceState } from "@/types/types";

export default defineComponent({
    name: "MultiviewSelectAllNotice",
    components: { SelectAllNotice },
    props: {
        instanceName: {
            required: true,
            type: String as PropType<"masterTemplates">
        }
    },

    data() {
        return {
            showNotice: false
        };
    },

    computed: {
        selected() {
            return this.state ? this.state.selected : 0;
        },

        isNoticeShown() {
            return this.showNotice && this.selected !== this.totalCount && this.selected;
        },

        state() {
            return (this.$store.state.ui.multiviewComponents as Record<string, InstanceState>)[this.instanceName];
        },

        totalCount() {
            return this.state ? this.state.totalCount : 0;
        }
    },

    created() {
        bus.$on(MultiviewEvent.SelectAllOnPage, this.onSelectAllOnPage.bind(this));
    },

    methods: {
        hideNotice() {
            this.showNotice = false;
        },

        onSelectAll() {
            bus.$emit(MultiviewEvent.SelectAll, {
                instance: this.instanceName
            });
        },

        onSelectAllOnPage(selectData: { instance: string; value: boolean }) {
            if (selectData.instance !== this.instanceName) {
                return;
            }

            this.showNotice = selectData.value;
        }
    }
});
</script>
